import type { LocalDict } from "../../core/i18n";

export const STR: LocalDict = {
  en: {
    "title": "Connection lost",
    "reconnecting": "Reconnecting to the server…",
    "elapsed": "Disconnected {n}s ago.",
    "starting.title": "Starting up",
    "starting.elapsed": "Waiting {n}s.",
    "starting.body":
      "The Olano runtime is still coming up. On a new instance the first boot can take a few minutes — this page connects on its own as soon as it's ready.",
    "down.title": "Server appears to be offline",
    "down.body": "The Olano runtime isn't responding — it may have been stopped or is still starting up. This page will reconnect automatically when it's back.",
    "down.body.managed":
      "The Olano runtime isn't responding. Your instance is hosted by Olano and restarts itself automatically — this page will reconnect as soon as it's back. If it stays down, check the deployment in your cloud console.",
    "down.cmd": "Or start it from a terminal:",
    "down.console": "Open the cloud console",
    "copy": "Copy",
    "copied": "Copied",
    "restart": "Restart server now",
    "restarting": "Restarting…",
    "restart.failed": "Couldn't trigger a restart automatically — start it from a terminal.",
    "backOnline": "Server is back online.",
    "pill.reconnecting": "Reconnecting…",
    "pill.booting": "Starting agents…",
    "pill.booting.count": "Starting agents — {n} of {total} ready",
  },
  es: {
    "title": "Conexión perdida",
    "reconnecting": "Reconectando con el servidor…",
    "elapsed": "Desconectado hace {n}s.",
    "starting.title": "Iniciando",
    "starting.elapsed": "Esperando {n}s.",
    "starting.body":
      "El runtime de Olano todavía se está iniciando. En una instancia nueva el primer arranque puede tardar unos minutos; esta página se conectará sola en cuanto esté lista.",
    "down.title": "El servidor parece estar caído",
    "down.body": "El runtime de Olano no responde: puede haberse detenido o estar iniciándose. Esta página se reconectará automáticamente cuando vuelva.",
    "down.body.managed":
      "El runtime de Olano no responde. Tu instancia está alojada por Olano y se reinicia sola: esta página se reconectará en cuanto vuelva. Si sigue caída, revisa el despliegue en tu consola cloud.",
    "down.cmd": "O inícialo desde una terminal:",
    "down.console": "Abrir la consola cloud",
    "copy": "Copiar",
    "copied": "Copiado",
    "restart": "Reiniciar el servidor ahora",
    "restarting": "Reiniciando…",
    "restart.failed": "No se pudo reiniciar automáticamente; inícialo desde una terminal.",
    "backOnline": "El servidor está de nuevo en línea.",
    "pill.reconnecting": "Reconectando…",
    "pill.booting": "Iniciando agentes…",
    "pill.booting.count": "Iniciando agentes — {n} de {total} listos",
  },
  zh: {
    "title": "连接已断开",
    "reconnecting": "正在重新连接服务器…",
    "elapsed": "已断开 {n} 秒。",
    "starting.title": "正在启动",
    "starting.elapsed": "已等待 {n} 秒。",
    "starting.body":
      "Olano 运行时仍在启动。新实例的首次启动可能需要几分钟——准备就绪后本页会自动连接。",
    "down.title": "服务器似乎已离线",
    "down.body": "Olano 运行时无响应——可能已停止或仍在启动。服务器恢复后本页将自动重新连接。",
    "down.body.managed":
      "Olano 运行时无响应。你的实例由 Olano 托管并会自动重启——恢复后本页将自动重新连接。若持续无响应，请在云控制台查看该部署。",
    "down.cmd": "或在终端中启动它：",
    "down.console": "打开云控制台",
    "copy": "复制",
    "copied": "已复制",
    "restart": "立即重启服务器",
    "restarting": "正在重启…",
    "restart.failed": "无法自动重启——请在终端中启动。",
    "backOnline": "服务器已恢复在线。",
    "pill.reconnecting": "正在重新连接…",
    "pill.booting": "正在启动智能体…",
    "pill.booting.count": "正在启动智能体 — 已就绪 {n}/{total}",
  },
};
